import(/* webpackMode: "eager" */ "/home/ubuntu/pdf-annotation-tool/src/app/page.tsx");
